"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setUpMandrel = void 0;
const c = __importStar(require("./constants"));
const utils_1 = require("./utils");
const MANDREL_REPO = 'mandrel';
const MANDREL_TAG_PREFIX = c.MANDREL_NAMESPACE;
const MANDREL_DL_BASE = 'https://github.com/graalvm/mandrel/releases/download';
function setUpMandrel(graalvmVersion, javaVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const mandrelVersion = graalvmVersion.substring(c.MANDREL_NAMESPACE.length, graalvmVersion.length);
        let mandrelHome;
        switch (mandrelVersion) {
            case 'latest':
                mandrelHome = yield setUpMandrelLatest(javaVersion);
                break;
            default:
                mandrelHome = yield setUpMandrelRelease(mandrelVersion, javaVersion);
                break;
        }
        return mandrelHome;
    });
}
exports.setUpMandrel = setUpMandrel;
function setUpMandrelLatest(javaVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const latestRelease = yield (0, utils_1.getLatestRelease)(MANDREL_REPO);
        const tag_name = latestRelease.tag_name;
        if (tag_name.startsWith(MANDREL_TAG_PREFIX)) {
            const latestVersion = tag_name.substring(MANDREL_TAG_PREFIX.length, tag_name.length);
            return setUpMandrelRelease(latestVersion, javaVersion);
        }
        throw new Error(`Could not find latest Mandrel release: ${tag_name}`);
    });
}
function setUpMandrelRelease(version, javaVersion) {
    return __awaiter(this, void 0, void 0, function* () {
        const identifier = determineMandrelIdentifier(version, javaVersion);
        const downloadUrl = `${MANDREL_DL_BASE}/${MANDREL_TAG_PREFIX}${version}/${identifier}${c.GRAALVM_FILE_EXTENSION}`;
        return (0, utils_1.downloadAndExtractJDK)(downloadUrl);
    });
}
function determineMandrelIdentifier(version, javaVersion) {
    return `mandrel-java${javaVersion}-${c.GRAALVM_PLATFORM}-amd64-${version}`;
}
